/** @format */

import { DepositContainer } from "./DepositContainer";

export default DepositContainer;